import { useLogEvent } from "../hooks/useLogEvent";

export const Rights = () => {

    const { handleLogEvent } = useLogEvent()

    return (

        <div className='rights__container'>

            <div className='rights__content-container uutils__fade-in'>

                <h3>{new Date().getFullYear()}© Faetani Techos - Todos los derechos reservados</h3>

                <a
                    className='rights__button'
                    href="https://www.instagram.com/batata.tecnologia/"
                    target="_blank"
                    rel="noreferrer"
                    onClick={() => {
                        handleLogEvent('Click_boton_batata');
                    }}
                >

                    <h3>Diseñado y desarrollado por <span>Batata Tecnología</span></h3>

                </a>

            </div>

        </div >

    )
}
